
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as offerApi from '@/api/resources/offerApi';
import { Offer } from '@/services/merchantSpace/types';

type State = 'form' | 'success';

@Component
export default class PartnerExchangeCard extends Vue {
  @Prop({ type: Object, required: true })
  readonly offer!: Offer;

  @Prop({ type: String, required: true })
  readonly userEmail!: string;

  @Prop({ type: Boolean, required: true })
  readonly value!: boolean;

  state: State = 'form';

  loading: boolean = false;

  email: string = '';

  errorMessage: string = '';

  @Watch('value')
  onOpen(val: boolean) {
    if (val) {
      this.state = 'form';
      this.errorMessage = '';
      this.email = this.userEmail;
    }
  }

  get show(): boolean {
    return this.value;
  }

  set show(val: boolean) {
    this.$emit('input', val);
  }

  async onConfirm() {
    this.loading = true;
    try {
      await offerApi.exchangePartnerOffer(this.offer.id, this.email);
      this.state = 'success';
    } catch (err) {
      console.log('err', err.response);
      if (err.response && err.response.status === 404) {
        this.errorMessage = "Désolé, nous n'avons pas pu trouver votre compte pour convertir vos points. Créer votre compte au https://www.vitrines-alencon.fr ou nous contacter au contact@vitrine-alencon.fr";
      } else {
        this.errorMessage =
          "Une erreur est survenue lors de la conversion de points. Vous pouvez retenter ultérieurement. Si le problème persiste, contactez le support.";
      }
    } finally {
      this.loading = false;
    }
  }


}
